import store from "./store";

const iframeId = "silent-refresh-iframe-93927c75-dcaf-445d-b4ce-12282747564c";
const silentRefreshStartedAtKey = "silentRefreshStartedAt";
const silentRefreshMaxAgeMs = 120000;
const silentRefreshWaitMs = 2000;
export const OAUTH_CLIENT_ID = "4ced930c-018a-6110-c9d3-b76a5609b9c2";

export function completeSilentRefresh() {
    localStorage.removeItem(silentRefreshStartedAtKey);
}

export function waitForSilentRefresh(currentToken, timeoutMs = silentRefreshWaitMs) {
    const startedAt = Number(localStorage.getItem(silentRefreshStartedAtKey));
    if (!startedAt || Date.now() - startedAt > silentRefreshMaxAgeMs) {
        return Promise.resolve(false);
    }

    return new Promise((resolve) => {
        let timeout;
        const finish = (refreshed) => {
            clearInterval(interval);
            clearTimeout(timeout);
            resolve(refreshed);
        };
        const hasNewToken = () => {
            const storedToken = localStorage.getItem("token");
            return storedToken && storedToken !== currentToken;
        };
        const interval = setInterval(() => {
            if (hasNewToken()) {
                finish(true);
            }
        }, 50);
        timeout = setTimeout(() => finish(Boolean(hasNewToken())), timeoutMs);
    });
}

function buildOAuthUrl({ originalRoute, silent = false, prompt = null }) {
    if (originalRoute) {
        localStorage.setItem("originalRoute", originalRoute);
    }
    const redirectPath = window.parent.origin + "/oauth/redirect";
    const oauthUrl = new URL(store().state.info.oauthUrl + "/oauth/authorize");
    oauthUrl.searchParams.set("response_type", "id_token");
    oauthUrl.searchParams.set("client_id", OAUTH_CLIENT_ID);
    oauthUrl.searchParams.set("scope", "openid");
    oauthUrl.searchParams.set("redirect_uri", redirectPath);
    if (prompt) {
        oauthUrl.searchParams.set("prompt", prompt);
    }
    if (silent) {
        oauthUrl.searchParams.set("prompt", "none");
    }
    return oauthUrl.toString();
}

export function redirectToLogin({silent, originalRoute, prompt = null}) {
    localStorage.removeItem("loggedOut");
    const oauthUrl = buildOAuthUrl({ originalRoute, silent, prompt });
    if (silent) {
        localStorage.setItem(silentRefreshStartedAtKey, `${Date.now()}`);
        if (window.document.getElementById(iframeId)) {
            window.document.getElementById(iframeId).remove();
        }
        let iframe = window.document.createElement("iframe");
        iframe.id = iframeId;
        iframe.setAttribute("src", oauthUrl)
        window.document.body.appendChild(iframe);
    } else {
        completeSilentRefresh();
        if (window.parent && window.parent !== window) {
            // Inside silent-refresh iFrame
            window.parent.location = oauthUrl;
        } else {
            // Called from router
            window.location = oauthUrl;
        }
    }
}

export function redirectToLogout() {
    localStorage.setItem("loggedOut", "true");
    window.location.assign("/logged-out");
}

export function redirectToLogoutThenLogin({ originalRoute = "/", prompt = "login" } = {}) {
    localStorage.removeItem("loggedOut");

    const oauthBaseUrl = store().state.info.oauthUrl;
    if (!oauthBaseUrl) {
        redirectToLogin({ silent: false, originalRoute, prompt });
        return;
    }

    const logoutUrl = new URL(oauthBaseUrl + "/logout.do");
    logoutUrl.searchParams.set("redirect", buildOAuthUrl({ originalRoute, prompt }));
    window.location.assign(logoutUrl.toString());
}
